// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__5D1PS","window":"styles_window__6-axf","content":"styles_content__E9TLR"};